import Badge, { BadgeColor } from '@components/Badge';
import { InquiryStatus } from '@models/inquiry';
import { useTranslation } from 'react-i18next';

interface Props {
    status: InquiryStatus;
}

const STATUS_COLORS: Record<InquiryStatus, BadgeColor> = {
    PENDING: 'red',
    FOLLOW_UP: 'red',
    ON_HOLD: 'red',
    ANSWERED: 'blue',
    CLOSED: 'gray',
};

function InquiryBadge({ status }:Props) {
    const { t } = useTranslation('inquiry');
    return (
        <Badge color={STATUS_COLORS[status]}>
            {t(`status.${status}`)}
        </Badge>
    );
}

export default InquiryBadge;
